import styled from "styled-components";
import { Wrapper } from "AppReact";

const Content = styled.div`
  width: 100%;
  border-bottom: 1px solid #E3E3E3;
  border-top: 1px solid #E3E3E3;
  padding: 12px;
`;

export default Wrapper(Content)